import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import useUser from 'utils/useUser';
import { isAdmin, isAgencyDoctor, isPractice } from 'utils/userTypeHelper';
import withLoader from 'components/organisms/withLoader';
import EditButton from 'components/atoms/editButton';
import { Card, CardBody, Col, Row } from 'reactstrap';
import AdminClinicThreshold from 'components/templates/admin/clinic/components/threshold';
import Contact from './components/contact';
import Registration from './components/registration';
import Address from './components/address';
import ClinicDetailsBlock from './components/clinicDetails';
import Representatives from './components/representatives';
import ClinicRunBookLogs from '../patient/components/clinicRunBookLogs';

const Clinic = () => {
  const { clinicGuid } = useParams();
  const { clinic } = useSelector((state) => state.adminPanelClinics);
  const { getClinic: clinicDetailsLoading } = useSelector(
    (state) => state.loading.effects.adminPanelClinics,
  );
  const { userType } = useUser();
  const iamAdminOrHHAOrPractice = useMemo(
    () => isAdmin(userType) || isPractice(userType) || isAgencyDoctor(userType),
    [userType],
  );

  return (
    <div className="admin-patient">
      <Card className="card-border">
        <CardBody>
          <div className="admin-patient-header">
            <div className="admin-patient--center">
              <span>Clinic's Info</span>
              {iamAdminOrHHAOrPractice && clinic.childClinics?.length > 0 && (
                <div className="clinic-detail-info__parent-flag clinic-detail-info__parent-flag--right">
                  <span>Parent</span>
                </div>
              )}
            </div>
            <div className="admin-patient-header-actions">
              <div className="admin-patient-header-actions-opted badge">
                PVR Lite
                <br />
                {clinic.acceptPvrLite ? '(Opted In)' : '(Opted Out)'}
              </div>
              <div className="admin-patient-header-actions-status badge">
                Status:
                <br />
                {clinic.status
                  ? clinic.status.charAt(0).toUpperCase() +
                    clinic.status.slice(1)
                  : 'Active'}
              </div>
              <div className="admin-patient-header-actions-edit">
                <Link
                  data-cy="clinic__edit-link"
                  to={`/admin/clinic/${clinicGuid}/edit`}
                >
                  <EditButton />
                </Link>
              </div>
            </div>
          </div>
          {withLoader(
            clinicDetailsLoading,
            <>
              {clinic && (
                <div className="admin-user-profile-block admin-patient-block">
                  <Row>
                    <Col>
                      <Contact data={clinic} />
                      <Registration data={clinic} />
                      <Representatives
                        clientSuccessOnboarding={
                          clinic?.clientSuccessOnboarding
                        }
                        clientSuccessScaling={clinic?.clientSuccessScaling}
                        salesRepresentative={clinic?.salesRepresentative}
                      />
                      <AdminClinicThreshold />
                    </Col>
                    <Col>
                      <Address data={clinic} />
                      <ClinicDetailsBlock data={clinic} />
                      <div className="user-profile-block admin-patient-block">
                        <ClinicRunBookLogs clinicGuid={clinic.guid} />
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </>,
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default Clinic;
